export default __webpack_public_path__ + "static/media/automation.49b11591.svg";